import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
// import mm from "../../images/logo.png";
// import Process from '../ProcessPage/Process'
import Process from "../processPage/Process";
import SignUp from "../SignupPage/SignUp";
// import Login from '../LoginPage/Login'
import Login from "../loginPage/Login";
import Uploads from "../../Pages/Uploads/Uploads";
import HomePage from "../../Pages/HomePage/HomePage";
import Task from "../../Pages/TasksPage/Task";
import Settings from "../../Pages/Settings/Settings";
import Reports from "../../Pages/Reports/Reports";
import Layout from "../Layout/Layout";
import Protected from "../Protected/Protected";
import { getAuth } from "firebase/auth";
import { BiLogOut } from "react-icons/bi";
import { RxDashboard } from "react-icons/rx";
import { getFunctions, httpsCallable } from "firebase/functions";
import { toast } from "react-toastify";
import {
  setDefaultCalendarPreference,
  setDefaultBotName,
  getUniversalInsights,
} from "../../functions";

import {
  arrayUnion
} from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { TRANSCRIPT_STATUS } from "../../redux/constants/appPayloadTypes";
import { useMutation } from "@tanstack/react-query";
import { IconButton, Tooltip } from "@mui/material";
import Meetings from "../../Pages/Meetings/Meetings";
import moment from "moment";
import Loader from "./../../components/Popups/Loader";
import { partialUpdateUser, getCurrentUser, getUser } from "./../../services/UserService"
import { 
  createUserCalendarMeetings,
  partialUpdateUserCalendarMeetings
} from "./../../services/UserCalendarMeetingService"
import { 
  createMeetings, partialUpdateMeetings, fetchMeetings, getMeetings
 } from "./../../services/MeetingService"
 import { 
  updateMeetingUsage
 } from "./../../services/StatsMeetingService"

/* eslint-disable react-hooks/exhaustive-deps */
const Dashboard = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const functions = getFunctions();
  const dispatch = useDispatch();
  // const [loading, setLoading] = useState(true);
  const getData = httpsCallable(functions, "getData", { timeout: 540000 });
  const getDataHindi = httpsCallable(functions, "getDataHindi", {
    timeout: 540000,
  });
  const getDataMultiLang = httpsCallable(functions, "getDataMultiLang", {
    timeout: 540000,
  });
  const getDataArabic = httpsCallable(functions, "getDataArabic", {
    timeout: 540000,
  });
  const [isLoading, setIsLoading] = useState(false);
  const sendMail = httpsCallable(functions, "sendMail");
  const { uid, userData } = useSelector((state) => state.authReducer);
  const DashboardComps = [
    {
      path: "/uploads",
      comp: <Uploads />,
    },
    {
      path: "/",
      comp: <HomePage />,
    },
    {
      path: "/task",
      comp: <Task />,
    },
    {
      path: "/settings",
      comp: <Settings />,
    },
    {
      path: "/meetings",
      comp: <Meetings />,
    },
  ];
  if(userData?.organisation_info?.organisation_role == "organisation_admin"){
    DashboardComps.push(
      {
        path: "/reports",
        comp: <Reports />,
      },
    )
  }
  const nonDashboardComps = [
    {
      path: "/upload",
      comp: <Process />,
    },
    {
      path: "/signup",
      comp: <SignUp />,
    },
    {
      path: "/login",
      comp: <Login />,
    },
  ];

  const [meetingDocId, setMeetingDocId] = useState();
  const { transcript_data } = useSelector((state) => state.appReducer);
  const { uploads } = useSelector((state) => state.uploadsReducer);

  const updateExistingMeet = async (calMeet, upload) => {
    let user = getCurrentUser();
    partialUpdateUserCalendarMeetings(user.uid, upload.id,
      {
        attendees: calMeet.attendees,
        attendeeEmails: calMeet.attendee_emails,
        botId: calMeet.bot_id,
        startTime: moment(calMeet.start_time).toDate(),
        endTime: moment(calMeet.end_time).toDate(),
        willRecord: calMeet.will_record,
        meetInvite: { meetId: calMeet?.meet_invite?.meeting_id || "" },
        meetingPlatform: calMeet?.meeting_platform || "",
      },
        (response) => {
          
        },
        (error) => {}
    )
  };

  const addNewMeetToFirebase = async (newDoc) => {
    let user = getCurrentUser();
    await createUserCalendarMeetings(user.uid, newDoc)
  };

  const fetchNewTokenAndThenMeetings = async () => {
    // const newAuthToken = (
    //   await getCalendarAuthToken({ user_id: localStorage.getItem("@auth") })
    // ).calendar_auth_token;
    // await setDoc(
    //   doc(db, `users/${localStorage.getItem("@auth")}`),
    //   { calendarAuthToken: newAuthToken, calendarAuthTimestamp: new Date() },
    //   { merge: true }
    // );
    // const newUserData = {
    //   ...userData,
    //   calendarAuthToken: newAuthToken,
    //   calendarAuthTimestamp: moment(),
    // };
    // import("../../redux/actions/authActions").then((ac) =>
    //   dispatch(ac.addUser(newUserData))
    // );
  };

  useEffect(() => {
    console.log(`Main.js useEffect run for userData and localStorage.getItem("@auth")`)
    if (userData) {
      if (localStorage.getItem("@auth") && userData?.calendarAuthToken) {
        if (
          !userData?.calendarAuthTimestamp ||
          (userData?.calendarAuthTimestamp &&
            moment().diff(
              moment(userData?.calendarAuthTimestamp).toDate(),
              "hours"
            ) > 20)
        ) {
          // if (window.location.pathname === "/meetings" || window.location.pathname === "/")
          //   toast.info("Generating calendar-auth-token")
          fetchNewTokenAndThenMeetings();
        } else {
          // if (window.location.pathname === "/meetings" || window.location.pathname === "/")
          //   toast.info("Refreshing calendar meetings")
          if (!userData?.defaultPreferenceSet) {
            const botName = auth?.currentUser?.displayName + "'s MeetMinutes";
            let user = getCurrentUser();
            setDefaultCalendarPreference({
              user_id: user.uid,
            }).then(() => {
              setDefaultBotName({
                user_id: user.uid,
                bot_name: auth?.currentUser?.displayName + "'s MeetMinutes",
              }).then(() => {
                partialUpdateUser(user.uid,
                  { defaultPreferenceSet: true, botName: botName },
                  (response) => { },
                  (error) => {}
                )
              });
            });
          }
        }
        import("../../redux/actions/appActions").then((ac) =>
          dispatch(ac.integrateCalendarPopup(false))
        );
      } else {
        if (!userData?.calendarAuthToken)
          import("../../redux/actions/appActions").then((ac) =>
            dispatch(ac.integrateCalendarPopup(true))
          );
      }
    }
  }, [userData, localStorage.getItem("@auth")]);

  const addNewMeeting = useMutation(async (props) => {
    // console.log("add new meeting called with props", props);
    let docId;
    let user = getCurrentUser();
    return createMeetings(
      {
        uid: user.uid,
        noOfParticipants: props.participants.length,
        participantList: props.participants,
        fileDetails: {
          name: props.fileName,
          fileId: props.fileId,
          type: props?.ftype || "",
          url: props.url,
          audioUrl: props?.audioUrl || "",
          audioDuration: props?.audioDuration || 0,
          charLen: props.fileContent?.length || 0,
          hashTag:
            props?.ftype.includes("audio") || props?.ftype.includes("video")
              ? "#AudioUploads"
              : "#TranscriptUploads",
        },
        transcript: props.transcriptVttFile,
        participants: {},
        createdAt: new Date(),
        language: props.language,
      },
      (response) => {
        let data = response.data;
        docId = data.id;
        setMeetingDocId(data.id);

        partialUpdateUser(user.uid,
          {
            meetings: [{
              id: docId,
              fileName: props.fileName,
              fileType: props?.ftype || "",
              participants: [props.participant],
              fileId: props.fileId,
              language: props.language,
            }],
          },
          (response) => { },
          (error) => {}
        )
        return docId;
      },
      (error) => {}
    )
  });

  const modifyMeeting = useMutation(async (props) => {
    console.log("modify meeting called", props, meetingDocId);
    getMeetings(meetingDocId,
      (response) => {
        const requiredMeetingData = response.data;

        console.log("meeting data before", requiredMeetingData, meetingDocId);
        partialUpdateMeetings(meetingDocId,
          {
            summary: transcript_data?.summary || "",
            questions: transcript_data?.questions,
            notes: transcript_data?.notes,
            participants: requiredMeetingData?.participants
              ? {
                  ...requiredMeetingData.participants,
                  [props.participant]: {
                    tasks: transcript_data?.useractionitem,
                    tasksForOthers: transcript_data?.otheractionitem,
                  },
                }
              : {
                  [props.participant]: {
                    tasks: transcript_data?.useractionitem,
                    tasksForOthers: transcript_data?.otheractionitem,
                  },
                },
          },
          (response) => {
            getMeetings(meetingDocId,
              (response2) => {
                let data2 = response2.data;
                import("../../redux/actions/appActions").then((actions) =>
                  dispatch(
                    actions.setTranscriptData({
                      ...data2,
                      useractionitem: data2.participants[props.participant].tasks,
                      otheractionitem: data2.participants[props.participant].tasksForOthers,
                      participant: props.participant,
                    })
                  )
                );
              },
              (error) => {}
            )
          },
          (error) => {}
        )
      },
      (error) => {}
    )
    console.log("meeting data modified");
  });

  useEffect(() => {
    if (localStorage.getItem("@auth")) {
      import("../../redux/actions/authActions").then((actions) =>
        dispatch(actions.addUID(localStorage.getItem("@auth")))
      );
    }
  }, [localStorage.getItem("@auth")]);

  //update uploadRecord in users Collection - start
  const updateUploadRecord = async () => {
    try {
      let user = getCurrentUser();
      getUser(user.uid,
        (response) => {
          const userData = response.data;
          if (userData) {
            // Check if uploadRecord field is present
            if (userData.uploadRecord !== undefined) {
              const newUploadRecordValue = userData.uploadRecord + 1;
              // Update the user document with the new uploadRecord value
              partialUpdateUser(user.uid, { uploadRecord: newUploadRecordValue },
                  (response) => {
                    console.log("UploadRecord updated:", newUploadRecordValue);     
                  },
                  (error) => {}
              )
            }
          } else {
            console.error("User not found.");
          }
        },
        (error) => {}
      )
    } catch (error) {
      console.error("Error updating uploadRecord:", error);
    }
  };

  //update uploadRecord in users Collection - end
  const reprocessData = async (props) => {
    console.log("props to reprocess", props);
    let docId = await addNewMeeting.mutateAsync(props);

    if (props.participant && props.transcriptVttFile) {
      console.log(" props.transcriptVttFile - ", props.transcriptVttFile);
      console.log(" props.participant - ", props.participant);

      const res = await getUniversalInsights({
        transcript_vtt: props.transcriptVttFile,
        participant: props.participant,
      });

      console.log(res, "hitting res");

      if (res) {
        await import("../../redux/actions/appActions").then((actions) =>
          dispatch(
            actions.setTranscriptData({
              summary: res.summary,
              notes: res.important_points,
              questions: res.questions,
              useractionitem: res.action_items_user,
              otheractionitem: res.action_items_others,
            })
          )
        );

        await modifyMeeting
          .mutateAsync({
            ...props,
            summary: res.summary,
            notes: res.important_points,
            questions: res.questions,
            useractionitem: res.action_items_user,
            otheractionitem: res.action_items_others,
          })
          .catch(() => {
            import("../../redux/actions/appActions").then((actions) =>
              dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
            );
          });

        await updateUploadRecord();
        toast.success("Processing done!");
        // console.log("line 678");
      } else {
        toast.error("Couldn't process transcript data, please try later!");
      }

      import("../../redux/actions/appActions").then((actions) =>
        dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
      );

      if (localStorage.getItem("@auth")) {
        fetchMeetings(dispatch);
        navigate("/uploads");
      } else {
        navigate("/login");
      }
    } else {
      toast.error("Upload transcript");
    }
  };

  const processForThisParticipant = async (props) => {
    console.log("process for this participant props: ", props);
    userData.meetings.forEach((meeting) => {
      if (meeting.fileId === props.fileId) {
        setMeetingDocId(meeting.id);
      }
    });
    if (props.participant && props.fileId) {
      let res;
      if (props.language === "english") {
        res = await getData({
          participant: props.participant,
          file_id: props.fileId,
        });
        // toast.success("english")
      } else if (props.language === "hindi") {
        res = await getDataHindi({
          participant: props.participant,
          file_id: props.fileId,
        });
        // toast.success("hindi")
      } else if (props.language === "arabic") {
        res = await getDataArabic({
          participant: props.participant,
          transcript_url: props.transcript_link,
          file_id: props.fileId,
        });
        // toast.success("hindi")
      } else
        res = await getDataMultiLang({
          participant: props.participant,
          file_id: props.fileId,
          language: props.language,
        });
      if (res.data?.result) {
        if (res.data.result.message === "completed") {
          // localStorage.setItem("transcript_data", res.data.result.body)
          await import("../../redux/actions/appActions").then((actions) =>
            dispatch(
              actions.setTranscriptData(JSON.parse(res.data.result.body))
            )
          );
          await modifyMeeting
            .mutateAsync({ ...props, ...JSON.parse(res.data.result.body) })
            .catch(() => {
              import("../../redux/actions/appActions").then((actions) =>
                dispatch(
                  actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED)
                )
              );
            });
          await updateUploadRecord();
          toast.success("Processing done!");
          console.log("line 790");
          sendMail({
            email: auth.currentUser.email,
            meetName: props?.fileName,
            name: auth.currentUser.displayName + " (yourself)",
            summary: JSON.parse(res.data.result.body)?.summary,
            notes: JSON.parse(res.data.result.body)?.notes,
            questions: JSON.parse(res.data.result.body)?.questions,
            tasks: JSON.parse(res.data.result.body)?.useractionitem,
            tasksForOthers: JSON.parse(res.data.result.body)?.otheractionitem,
          });
        } else {
          toast.error("Couldn't process transcript data, please try later!");
        }
      } else {
        if (res.data.message === "completed") {
          // localStorage.setItem("transcript_data", res.data.body)
          await import("../../redux/actions/appActions").then((actions) =>
            dispatch(actions.setTranscriptData(JSON.parse(res.data.body)))
          );
          await modifyMeeting
            .mutateAsync({ ...props, ...JSON.parse(res.data.body) })
            .catch(() => {
              import("../../redux/actions/appActions").then((actions) =>
                dispatch(
                  actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED)
                )
              );
            });
          await updateUploadRecord();
          toast.success("Processing done!");
          console.log("line 820");
          sendMail({
            email: auth.currentUser.email,
            meetName: props.fileName,
            name: auth.currentUser.displayName + " (yourself)",
            summary: JSON.parse(res.data.body)?.summary,
            notes: JSON.parse(res.data.body)?.notes,
            questions: JSON.parse(res.data.body)?.questions,
            tasks: JSON.parse(res.data.body)?.useractionitem,
            tasksForOthers: JSON.parse(res.data.body)?.otheractionitem,
          });
        } else {
          toast.error("Couldn't process transcript data, please try later!");
        }
      }
      //to update user doc and add new participant into meetings key
      await (async () => {
        let idx;
        let userMeetings = userData.meetings;
        console.log("user meeting", userMeetings);
        userData.meetings.forEach((meeting, indx) => {
          if (meeting.fileId === props.fileId) {
            idx = indx;
          }
        });
        console.log("index", idx);
        console.log("userMeeting[", idx, "] before", userMeetings[idx]);
        userMeetings[idx] = {
          ...userMeetings[idx],
          participants: [...userMeetings[idx].participants, props.participant],
        };
        console.log("userMeeting[", idx, "] after", userMeetings[idx]);
        let user = getCurrentUser();
        partialUpdateUser(user.uid, { meetings: userMeetings },
            (response) => {},
            (error) => {}
        )
      })().catch(() => {
        import("../../redux/actions/appActions").then((actions) =>
          dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
        );
      });
      import("../../redux/actions/appActions").then((actions) =>
        dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
      );
      if (localStorage.getItem("@auth")) {
        fetchMeetings(dispatch);
      } else {
        navigate("/login");
      }
    } else {
      toast.error("Upload transcript");
    }
  };

  //background processing of transcript added while a user is logged in
  //for bg processing of data
  useEffect(() => {
    if (localStorage.getItem("@auth")) {
      const data = JSON.parse(localStorage.getItem("bgProcessing"));
      if (data) {
        import("../../redux/actions/appActions").then((actions) =>
          dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSING))
        );
        bgProcessData({ ...data, audioUrl: data.firebaseUrl });
      }
    }
  }, [localStorage.getItem("bgProcessing")]);

  const bgProcessData = async (props) => {
    const meetings = uploads;
    let alreadyProcessed = false;
    let notProcessedForThisParticipant = false;

    userData?.meetings?.forEach((meeting) => {
      if (
        meeting.fileId === props.fileId ||
        (meeting.transcript_link &&
          meeting.participants.includes(props.participant) &&
          (meeting?.language ? meeting.language === props.language : true))
      ) {
        alreadyProcessed = true;
      } else if (
        meeting.fileId === props.fileId &&
        !meeting.participants.includes(props.participant)
      ) {
        notProcessedForThisParticipant = true;
      }
    });
    if (alreadyProcessed && !props?.forceReprocess) {
      meetings.forEach((meeting) => {
        if (
          meeting?.fileDetails?.fileId === props.fileId &&
          (meeting?.language ? meeting.language === props.language : true)
        ) {
          console.log("found processed meeting for user", meeting);
          import("../../redux/actions/appActions").then((actions) =>
            dispatch(
              actions.setTranscriptData({
                ...meeting,
                useractionitem:
                  meeting?.participants[props.participant]?.tasks || "",
                otheractionitem:
                  meeting?.participants[props.participant]?.tasksForOthers ||
                  "",
                participant: props.participant,
              })
            )
          );
          import("../../redux/actions/appActions").then((actions) =>
            dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
          );
        }
      });
    } else if (notProcessedForThisParticipant && !props?.forceReprocess) {
      console.log("data reprocessed for another participant");
      await processForThisParticipant(props)
        .then(() => {
          updateMeetingUsage({
            seconds: parseInt(props.audioDuration),
            uid: localStorage.getItem("@auth"),
          });
        })
        .finally(() => {
          localStorage.removeItem("bgProcessing");
          import("../../redux/actions/appActions").then((actions) =>
            dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
          );
        });
    } else {
      console.log("data reprocessed");
      await reprocessData(props)
        .then(() => {
          updateMeetingUsage({
            seconds: parseInt(props.audioDuration),
            uid: localStorage.getItem("@auth"),
          });
        })
        .finally(() => {
          localStorage.removeItem("bgProcessing");
          import("../../redux/actions/appActions").then((actions) =>
            dispatch(actions.setTranscriptStatus(TRANSCRIPT_STATUS.PROCESSED))
          );
        });
    }
    localStorage.removeItem("bgProcessing");
  };

  return (
    <div className="relative">
      <Loader isLoading={isLoading} />
      <div>
        <Routes>
          {nonDashboardComps.map((x, idx) => {
            return (
              <Route
                key={idx}
                path={x.path}
                element={
                  <div className="flex relative w-full h-[100vh] items-center justify-center">
                    {x.path === "/upload" && (
                      <>
                        {localStorage.getItem("@auth") ? (
                          <div
                            className="absolute text-2xl left-3 top-3 cursor-pointer transition hover:scale-110"
                            onClick={() => {
                              navigate("/");
                            }}
                          >
                            <Tooltip title="Dashboard">
                              <IconButton>
                                <RxDashboard />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ) : (
                          <div
                            className="absolute text-2xl left-3 top-3 cursor-pointer transition hover:scale-110"
                            onClick={() => {
                              navigate("/login");
                            }}
                          >
                            <div className="text-[18px] text-[white] bg-[#07457F] px-[30px] py-[5px] rounded-[10px]">
                              Login
                            </div>
                            {/* <IconButton>
                              <BiLogInCircle />
                      </IconButton> */}
                          </div>
                        )}
                        {localStorage.getItem("@auth") && (
                          <div
                            className="absolute text-2xl right-3 top-3 cursor-pointer transition hover:scale-110"
                            onClick={() => {
                              auth.signOut();
                              localStorage.clear();
                              import("../../redux/actions/authActions").then(
                                (actions) => dispatch(actions.logout())
                              );
                              navigate("/login");
                            }}
                          >
                            <Tooltip title="Logout">
                              <IconButton>
                                <BiLogOut />
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                      </>
                    )}
                    {x.comp}
                  </div>
                }
              />
            );
          })}
          {DashboardComps.map((x, idx) => {
            return (
              <Route
                key={idx}
                path={x.path}
                element={
                  <Protected>
                    <Layout>{x.comp}</Layout>
                  </Protected>
                }
              />
            );
          })}
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
